"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmeticSectionTitles = exports.VehicleModelSeriesFieldIds = exports.VehicleModelFieldIds = exports.VehicleMakeFieldIds = exports.VehicleConfigurationFieldIds = exports.VarnishFieldIds = exports.TireSetFieldIds = exports.PackageFieldIds = exports.InteriorFieldIds = exports.AccessoryFieldIds = void 0;
var AccessoryFieldIds;
(function (AccessoryFieldIds) {
    AccessoryFieldIds["ARTICLE_NAME"] = "article-name";
    AccessoryFieldIds["ARTICLE_NUMBER"] = "article-number";
    AccessoryFieldIds["ASSEMBLY_HOURS"] = "assembly-hours";
    AccessoryFieldIds["ASSEMBLY_PRICE"] = "assembly-price";
    AccessoryFieldIds["ASSEMBLY_PRICE_EXCLUDING_VAT"] = "assembly-price-excluding-vat";
    AccessoryFieldIds["DESCRIPTION"] = "description";
    AccessoryFieldIds["IMAGES"] = "images";
    AccessoryFieldIds["MODEL_COMPATIBILITY"] = "model-compatibility";
    AccessoryFieldIds["RETAILER_MARGIN"] = "retailer-margin";
    AccessoryFieldIds["RETAILER_MARGIN_EXCLUDING_VAT"] = "retailer-margin-excluding-vat";
    AccessoryFieldIds["RETAIL_PRICE"] = "retail-price";
    AccessoryFieldIds["RETAIL_PRICE_EXCLUDING_VAT"] = "retail-price-excluding-vat";
})(AccessoryFieldIds = exports.AccessoryFieldIds || (exports.AccessoryFieldIds = {}));
var InteriorFieldIds;
(function (InteriorFieldIds) {
    InteriorFieldIds["IMAGES"] = "images";
    InteriorFieldIds["INTERIOR_CODE"] = "interior-code";
    InteriorFieldIds["TYPE"] = "type";
})(InteriorFieldIds = exports.InteriorFieldIds || (exports.InteriorFieldIds = {}));
var PackageFieldIds;
(function (PackageFieldIds) {
    PackageFieldIds["ADDITIONAL_PRICE"] = "additional-price";
    PackageFieldIds["EQUIPMENT"] = "equipment";
})(PackageFieldIds = exports.PackageFieldIds || (exports.PackageFieldIds = {}));
var TireSetFieldIds;
(function (TireSetFieldIds) {
    TireSetFieldIds["DESCRIPTION"] = "description";
    TireSetFieldIds["IMAGES"] = "images";
    TireSetFieldIds["NOWA_CODE"] = "nowa-code";
    TireSetFieldIds["RIM_MANUFACTURER"] = "rim-manufacturer";
    TireSetFieldIds["SPIKES"] = "spikes";
    TireSetFieldIds["TIRE_MANUFACTURER"] = "tire-manufacturer";
    TireSetFieldIds["WINTER_WHEEL"] = "winter-wheel";
})(TireSetFieldIds = exports.TireSetFieldIds || (exports.TireSetFieldIds = {}));
var VarnishFieldIds;
(function (VarnishFieldIds) {
    VarnishFieldIds["COMPATIBILITY"] = "compatibility";
    VarnishFieldIds["HEX_CODE"] = "hex-code";
    VarnishFieldIds["TYPE"] = "type";
    VarnishFieldIds["VARNISH_CODE"] = "varnish-code";
})(VarnishFieldIds = exports.VarnishFieldIds || (exports.VarnishFieldIds = {}));
var VehicleConfigurationFieldIds;
(function (VehicleConfigurationFieldIds) {
    VehicleConfigurationFieldIds["CUSTOMER_ADVANTAGE"] = "customer-advantage";
    VehicleConfigurationFieldIds["CUSTOMER_ADVANTAGE_EXCLUDING_VAT"] = "customer-advantage-excluding-vat";
    VehicleConfigurationFieldIds["DELIVERY_CHARGE"] = "delivery-charge";
    VehicleConfigurationFieldIds["DELIVERY_CHARGE_EXCLUDING_VAT"] = "delivery-charge-excluding-vat";
    VehicleConfigurationFieldIds["EXTRA_BATTERY_CAPACITY"] = "extra-battery-capacity";
    VehicleConfigurationFieldIds["EXTRA_CHARGING_CAPACITY_AC"] = "extra-charging-capacity-ac";
    VehicleConfigurationFieldIds["EXTRA_CHARGING_CAPACITY_DC"] = "extra-charging-capacity-dc";
    VehicleConfigurationFieldIds["EXTRA_EFFECT"] = "extra-effect";
    VehicleConfigurationFieldIds["EXTRA_ELECTRIC_RANGE"] = "extra-electric-range";
    VehicleConfigurationFieldIds["EXTRA_TOWING_CAPACITY"] = "extra-towing-capacity";
    VehicleConfigurationFieldIds["GROSS_CUSTOMER_PRICE"] = "gross-customer-price";
    VehicleConfigurationFieldIds["GROSS_CUSTOMER_PRICE_EXCLUDING_VAT"] = "gross-customer-price-excluding-vat";
    VehicleConfigurationFieldIds["IMPORTER_SUPPORT"] = "importer-support";
    VehicleConfigurationFieldIds["IMPORTER_SUPPORT_EXCLUDING_VAT"] = "importer-support-excluding-vat";
    VehicleConfigurationFieldIds["INDICATIVE_PRICE"] = "indicative-price";
    VehicleConfigurationFieldIds["INDICATIVE_PRICE_EXCLUDING_VAT"] = "indicative-price-excluding-vat";
    VehicleConfigurationFieldIds["LEASING_INTEREST_RATE"] = "leasing-interest-rate";
    VehicleConfigurationFieldIds["LOAN_INTEREST_RATE"] = "loan-interest-rate";
    VehicleConfigurationFieldIds["MODEL"] = "model";
    VehicleConfigurationFieldIds["NET_CUSTOMER_PRICE_INCLUDINGVAT"] = "netCustomerPriceIncludingVat";
    VehicleConfigurationFieldIds["OPTION_PACKAGES"] = "option-packages";
    VehicleConfigurationFieldIds["PRICE_EXCLUDING_VAT"] = "price-excluding-vat";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_3Y_30K"] = "residual-value-3y30k";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_3Y_30K_EXCLUDING_VAT"] = "residual-value-3y30k-excluding-vat";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_3Y_45K"] = "residual-value-3y45k";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_3Y_45K_EXCLUDING_VAT"] = "residual-value-3y45k-excluding-vat";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_3Y_60K"] = "residual-value-3y60k";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_3Y_60K_EXCLUDING_VAT"] = "residual-value-3y60k-excluding-vat";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_4Y_40K"] = "residual-value-4y40k";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_4Y_40K_EXCLUDING_VAT"] = "residual-value-4y40k-excluding-vat";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_4Y_60K"] = "residual-value-4y60k";
    VehicleConfigurationFieldIds["RESIDUAL_VALUE_4Y_60K_EXCLUDING_VAT"] = "residual-value-4y60k-excluding-vat";
    VehicleConfigurationFieldIds["RETAILER_BASIC_MARGIN"] = "retailer-basic-margin";
    VehicleConfigurationFieldIds["RETAILER_BASIC_MARGIN_EXCLUDING_VAT"] = "retailer-basic-margin-excluding-vat";
    VehicleConfigurationFieldIds["RETAILER_CAMPAIGN_MARGIN"] = "retailer-campaign-margin";
    VehicleConfigurationFieldIds["RETAILER_CAMPAIGN_MARGIN_EXCLUDING_VAT"] = "retailer-campaign-margin-excluding-vat";
    VehicleConfigurationFieldIds["RETAILER_MARGIN_EQUIPMENT"] = "retailer-margin-equipment";
    VehicleConfigurationFieldIds["RETAILER_MARGIN_VEHICLE"] = "retailer-margin-vehicle";
    VehicleConfigurationFieldIds["RETAILER_SUPPORT"] = "retailer-support";
    VehicleConfigurationFieldIds["RETAILER_SUPPORT_EXCLUDING_VAT"] = "retailer-support-excluding-vat";
    VehicleConfigurationFieldIds["RIMS"] = "rims";
    VehicleConfigurationFieldIds["SALES_PACKAGES"] = "sales-packages";
    VehicleConfigurationFieldIds["SUGGESTED_EQUIPMENT_PRICE"] = "suggested-equipment-price";
    VehicleConfigurationFieldIds["SUGGESTED_EQUIPMENT_PRICE_EXCLUDING_VAT"] = "suggested-equipment-price-excluding-vat";
    VehicleConfigurationFieldIds["SUGGESTED_VEHICLE_PRICE"] = "suggested-vehicle-price";
    VehicleConfigurationFieldIds["SUGGESTED_VEHICLE_PRICE_EXCLUDING_VAT"] = "suggested-vehicle-price-excluding-vat";
    VehicleConfigurationFieldIds["VEHICLE_ROAD_TAX"] = "vehicle-road-tax";
    VehicleConfigurationFieldIds["VEHICLE_ROAD_TAX_EXCLUDING_VAT"] = "vehicle-road-tax-excluding-vat";
    VehicleConfigurationFieldIds["WRECKAGE"] = "wreckage";
    VehicleConfigurationFieldIds["WRECKAGE_EXCLUDING_VAT"] = "wreckage-excluding-vat";
})(VehicleConfigurationFieldIds = exports.VehicleConfigurationFieldIds || (exports.VehicleConfigurationFieldIds = {}));
var VehicleMakeFieldIds;
(function (VehicleMakeFieldIds) {
    VehicleMakeFieldIds["DESCRIPTION"] = "description";
    VehicleMakeFieldIds["LOGO"] = "logo";
    VehicleMakeFieldIds["URL"] = "url";
})(VehicleMakeFieldIds = exports.VehicleMakeFieldIds || (exports.VehicleMakeFieldIds = {}));
var VehicleModelFieldIds;
(function (VehicleModelFieldIds) {
    VehicleModelFieldIds["BATTERY_CAPACITY"] = "battery-capacity";
    VehicleModelFieldIds["BODYWORK"] = "bodywork";
    VehicleModelFieldIds["CHARGING_CAPACITY_AC"] = "charging-capacity-ac";
    VehicleModelFieldIds["CHARGING_CAPACITY_DC"] = "charging-capacity-dc";
    VehicleModelFieldIds["CONSUMPTION"] = "consumption";
    VehicleModelFieldIds["COSMETIC_PRICING"] = "cosmetic-pricing";
    VehicleModelFieldIds["COSMETIC_RECOMMENDATIONS"] = "cosmetic-recommendations";
    VehicleModelFieldIds["EFFECT"] = "effect";
    VehicleModelFieldIds["ELECTRIC_RANGE"] = "electric-range";
    VehicleModelFieldIds["EQUIPMENT"] = "equipment";
    VehicleModelFieldIds["FUEL_TYPE"] = "fuel-type";
    VehicleModelFieldIds["IMAGES"] = "images";
    VehicleModelFieldIds["INTERIORS"] = "interiors";
    VehicleModelFieldIds["LUGGAGE_VOLUME"] = "luggage-volume";
    VehicleModelFieldIds["MODEL_SERIES"] = "model-series";
    VehicleModelFieldIds["POWERTRAIN"] = "powertrain";
    VehicleModelFieldIds["SALES_ARTICLE"] = "sales-article";
    VehicleModelFieldIds["SEAT_COUNT"] = "seat-count";
    VehicleModelFieldIds["TIRES"] = "tires";
    VehicleModelFieldIds["TOWING_CAPACITY"] = "towing-capacity";
    VehicleModelFieldIds["TRANSMISSION"] = "transmission";
    VehicleModelFieldIds["VEHICLE_TYPE"] = "vehicle-type";
    VehicleModelFieldIds["YEAR"] = "year";
})(VehicleModelFieldIds = exports.VehicleModelFieldIds || (exports.VehicleModelFieldIds = {}));
var VehicleModelSeriesFieldIds;
(function (VehicleModelSeriesFieldIds) {
    VehicleModelSeriesFieldIds["ACCESSORIES"] = "accessories";
    VehicleModelSeriesFieldIds["COSMETIC_PRICING"] = "cosmetic-pricing";
    VehicleModelSeriesFieldIds["COSMETIC_RECOMMENDATIONS"] = "cosmetic-recommendations";
    VehicleModelSeriesFieldIds["MAKE"] = "make";
    VehicleModelSeriesFieldIds["VARNISHES"] = "varnishes";
})(VehicleModelSeriesFieldIds = exports.VehicleModelSeriesFieldIds || (exports.VehicleModelSeriesFieldIds = {}));
/**
 * This is used for finding the correct pricing/recommendation
 * table when aggregating data from PIM
 */
var CosmeticSectionTitles;
(function (CosmeticSectionTitles) {
    CosmeticSectionTitles["INTERIORS"] = "Interiors";
    CosmeticSectionTitles["TIRES"] = "Tires";
    CosmeticSectionTitles["VARNISHES"] = "Varnishes";
    CosmeticSectionTitles["ACCESSORIES"] = "Accessories";
})(CosmeticSectionTitles = exports.CosmeticSectionTitles || (exports.CosmeticSectionTitles = {}));
//# sourceMappingURL=crystallize-pim.js.map